module.exports = __webpack_public_path__ + "img/gym.fac8ce7.svg";